export enum ShiftEnrolmentType {
  permanent = 1,
  casual = 2,
  emergency = 3,
}

export namespace ShiftEnrolmentType {
  export function all(): ShiftEnrolmentType[] {
    return [
      ShiftEnrolmentType.permanent,
      ShiftEnrolmentType.casual,
      ShiftEnrolmentType.emergency,
    ];
  }

  export function toString(type: ShiftEnrolmentType): string {
    switch (type) {
      case ShiftEnrolmentType.permanent:
        return "Permanent";
      case ShiftEnrolmentType.casual:
        return "Casual";
      case ShiftEnrolmentType.emergency:
        return "Emergency";
    }
  }
}
